import { render, staticRenderFns } from "./ProviderTable.vue?vue&type=template&id=417ef530&scoped=true&"
import script from "./ProviderTable.vue?vue&type=script&lang=js&"
export * from "./ProviderTable.vue?vue&type=script&lang=js&"
import style0 from "./ProviderTable.vue?vue&type=style&index=0&id=417ef530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ef530",
  null
  
)

export default component.exports